/* eslint-disable max-len */
import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatHeader1NewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.25 3.75C4.80228 3.75 5.25 4.19772 5.25 4.75V11H12.75V4.75C12.75 4.19772 13.1977 3.75 13.75 3.75C14.3023 3.75 14.75 4.19772 14.75 4.75V12V19.25C14.75 19.8023 14.3023 20.25 13.75 20.25C13.1977 20.25 12.75 19.8023 12.75 19.25V13H5.25V19.25C5.25 19.8023 4.80228 20.25 4.25 20.25C3.69772 20.25 3.25 19.8023 3.25 19.25V4.75C3.25 4.19772 3.69772 3.75 4.25 3.75Z'
            fill='currentColor'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.0423 12.5448C19.6721 11.915 20.749 12.3611 20.749 13.2518V19.2502C20.749 19.8024 20.3014 20.25 19.7492 20.25C19.1971 20.25 18.7494 19.8024 18.7494 19.2502L18.7495 15.6654L18.1639 16.251C17.7734 16.6414 17.1404 16.6414 16.75 16.251C16.3596 15.8606 16.3596 15.2276 16.75 14.8372L19.0423 12.5448Z'
            fill='currentColor'
        />
    </svg>
));
